// react core
import { useContext, useState } from "react";

// material design
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
// import Modal from "@mui/material/Modal";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp as iconUp } from "@fortawesome/pro-duotone-svg-icons";
import { faChevronDown as iconDown } from "@fortawesome/pro-duotone-svg-icons";
import { faQrcode as iconTickets } from "@fortawesome/pro-duotone-svg-icons";
import { faRunning as iconRunner } from "@fortawesome/pro-duotone-svg-icons";
import { faToggleOn as iconCriteria } from "@fortawesome/pro-duotone-svg-icons";
import { faImage as iconBanner } from "@fortawesome/pro-duotone-svg-icons";
import { faImages as iconGallery } from "@fortawesome/pro-duotone-svg-icons";
import { faInfoCircle as iconInfo } from "@fortawesome/pro-duotone-svg-icons";
import { faMapMarkedAlt as iconLocations } from "@fortawesome/pro-duotone-svg-icons";
import { faUsers as iconMembers } from "@fortawesome/pro-duotone-svg-icons";
import { faCog as iconSettings } from "@fortawesome/pro-thin-svg-icons";
import { faEnvelope as iconContact } from "@fortawesome/pro-thin-svg-icons";
import { faSignIn as iconConnect } from "@fortawesome/pro-thin-svg-icons";
import { faUsersViewfinder as iconTribe } from "@fortawesome/pro-duotone-svg-icons";
import { faBullhorn as iconSocials } from "@fortawesome/pro-duotone-svg-icons";
import { faTimes as iconClose } from "@fortawesome/pro-thin-svg-icons";
import { faClone as iconClone } from "@fortawesome/pro-duotone-svg-icons";

// entzy resources
import configEntzy from "components/config/ConfigEntzy";

// entzy context and services
import { MainContext } from "components/main/MainContext";
import { EventContext } from "components/event/EventContext";
import {
  MenuSidebarButton,
  MenuAccordionButton,
} from "components/menu/MenuEvent";
import { ActionBoxButton } from "components/utils/common/CommonButtons";
import { ActionLoader } from "components/utils/common/CommonLoaders";

// entzy room sub components
// import ActionCore from "../actions/ActionCore";

function RoomRunnerZone(props) {
  const user = props.user;
  const handleToggleMenu = props.handleToggleMenu;

  const mainContext = useContext(MainContext);
  const eventContext = useContext(EventContext);

  const [showContact, setShowContact] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShowContact = () => {
    setShowContact(!showContact);
  };

  const handleShowSections = () => {
    mainContext.updateViewerTrail({
      showActionSettings: !mainContext.state.viewer.trail.showActionSettings,
    });
  };

  const handleActionToggle = (section) => {
    setLoading(true);
    if (mainContext.state.actionDrawer.open) {
      mainContext.setActionDrawer({
        open: false,
        params: {},
      });
      setLoading(false);
    } else {
      setTimeout(() => {
        mainContext.setActionDrawer({
          open: true,
          params: {
            room: "launchpad",
            section: section.id,
          },
        });
        setTimeout(() => {
          setLoading(false);
        }, 200);
      }, 100);
    }
  };

  const sections = props.sections || [];
  const sectionList = [
    {
      id: "criteria",
      text: "Launch Criteria",
      icon: iconCriteria,
    },
    { id: "details", text: "Launch Details", icon: iconInfo },
    { id: "locations", text: "Launch Location", icon: iconLocations },
    { id: "tickets", text: "Offer Types", icon: iconTickets },
    { id: "banner", text: "Image Banner", icon: iconBanner },
    { id: "gallery", text: "Image Gallery", icon: iconGallery },
    {
      id: "members",
      text: "Runners & Riders",
      icon: iconMembers,
      color: "black",
      bgColor: "primary.dark",
      blockHeader: true,
    },
    {
      id: "tribe",
      text: "Broadcast to Tribes",
      icon: iconTribe,
      color: "white",
      bgColor: "purple",
      blockHeader: true,
    },
    {
      id: "socials",
      text: "Broadcast on Socials",
      icon: iconSocials,
      bgColor: "purple",
    },
    {
      id: "clone",
      text: "Clone Eventuator",
      icon: iconClone,
      bgColor: "green",
      blockHeader: true,
    },
  ];

  return (
    <Box className="box-default">
      <Box className="box-default" hidden={user.connected}>
        {props.buttonType === "accordion" ? (
          <MenuAccordionButton
            icon={iconConnect}
            text="Connect"
            bgColor="dusk.main"
            onClick={() => props.drawerConnectToggle()}
          />
        ) : (
          <MenuSidebarButton
            icon={iconConnect}
            hideText={true}
            bgColor="none"
            textColor="white"
            autoWidth={true}
            onClick={() => props.drawerConnectToggle()}
          />
        )}
      </Box>
      <Box className="box-default" hidden={!user.connected} sx={props.boxSx}>
        {eventContext.state.event.manager ? (
          <Box className="box-default">
            {props.buttonType === "accordion" ? (
              <MenuAccordionButton
                icon={iconSettings}
                text="Settings"
                bgColor="dusk.main"
                onClick={handleShowSections}
              />
            ) : (
              <MenuSidebarButton
                icon={iconSettings}
                hideText={true}
                bgColor="none"
                textColor="white"
                autoWidth={true}
                onClick={handleShowSections}
              />
            )}
          </Box>
        ) : (
          <Box className="box-default">
            {props.buttonType === "accordion" ? (
              <MenuAccordionButton
                icon={iconContact}
                text="Contact"
                bgColor="dusk.main"
                onClick={handleShowContact}
              />
            ) : (
              <MenuSidebarButton
                icon={iconContact}
                hideText={true}
                bgColor="none"
                textColor="white"
                autoWidth={true}
                onClick={handleShowContact}
              />
            )}
          </Box>
        )}

        {/* <ActionBoxButton
          size="medium"
          bgColor="black"
          color="white"
          text="Manage Launch Settings"
          textNoCasing={true}
          border={true}
          borderColor="#e942f5"
          fullWidth={true}
          onClick={handleShowSections}
          endIcon={
            <FontAwesomeIcon
              icon={
                mainContext.state.actionDrawer.open ? iconClose : iconSettings
              }
              fixedWidth
              transform="grow-8 left-2"
            />
          }
        /> */}

        {/* <Typography variant="subtitle2">
          <span className="fa-layers fa-fw fa-3x">
            <FontAwesomeIcon icon={iconCircle} color="black" />
            <FontAwesomeIcon
              icon={iconSettings}
              color="white"
              transform="shrink-8"
            />
          </span>
        </Typography> */}
      </Box>

      <Drawer
        anchor="bottom"
        open={showContact}
        onClose={handleShowContact}
        sx={{
          zIndex: 999,
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box
          className="box-default bg-black"
          sx={{
            p: configEntzy.APP_SPACING_MD,
          }}
        >
          <Typography
            variant="h6"
            color="primary"
            className="text-right action-pointer"
            sx={{
              pt: configEntzy.APP_SPACING_MD,
              pr: configEntzy.APP_SPACING_MD,
            }}
            onClick={handleShowContact}
          >
            <FontAwesomeIcon
              icon={iconClose}
              transform="grow-4"
              color="white"
            />
          </Typography>
          <Container maxWidth="xs">
            <Typography
              variant="h6"
              color="primary"
              className="text-center"
              sx={{
                pt: configEntzy.APP_SPACING_MD,
              }}
            >
              <FontAwesomeIcon icon={iconContact} size="4x" color="white" />
            </Typography>
            <Typography
              variant="h6"
              color="primary"
              className="text-center"
              sx={{
                pt: configEntzy.APP_SPACING_MD,
              }}
            >
              Contact the Run Team
            </Typography>
            <Typography
              variant="subtitle1"
              color="white"
              className="text-center text-paragraph"
              sx={{
                pt: configEntzy.APP_SPACING_MD2X,
                pb: configEntzy.APP_SPACING_MD2X,
              }}
            >
              To reach the run team directly in a private channel, jump over to
              the chat area and post in the Front Desk chat room.
            </Typography>
          </Container>
          <Box
            className="box-default"
            sx={{
              p: configEntzy.APP_SPACING_LG,
            }}
          >
            <ActionBoxButton
              size="medium"
              bgColor="primary.main"
              color="black"
              text="Open Front Desk Chat"
              textNoCasing={true}
              fullWidth={true}
              onClick={() => {
                eventContext.setMessageRoom("desk");
                eventContext.focusModule("messaging");
                if (handleToggleMenu) handleToggleMenu(false);
                handleShowContact();
              }}
              endIcon={
                <FontAwesomeIcon
                  icon={iconContact}
                  fixedWidth
                  transform="grow-8 left-2"
                />
              }
            />
          </Box>
        </Box>
      </Drawer>

      <Drawer
        anchor="bottom"
        open={
          mainContext.state.viewer.trail.showActionSettings &&
          !mainContext.state.actionDrawer.open
        }
        onClose={handleShowSections}
        sx={{
          zIndex: 999,
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box
          className={
            loading
              ? "box-default full-height bg-black-t75"
              : "box-default bg-black"
          }
        >
          <Box
            className="box-default text-right action-pointer"
            sx={{
              pt: configEntzy.APP_SPACING_MD2X,
              pr: configEntzy.APP_SPACING_MD2X,
            }}
            onClick={handleShowSections}
          >
            <Typography variant="h6" color="white">
              {!mainContext.state.viewer.trail.showActionSettings && (
                <FontAwesomeIcon
                  icon={
                    mainContext.state.viewer.trail.showActionSettings
                      ? iconUp
                      : iconDown
                  }
                  transform="left-18 grow-4"
                  color="white"
                />
              )}
              <FontAwesomeIcon
                icon={
                  mainContext.state.viewer.trail.showActionSettings
                    ? iconClose
                    : iconSettings
                }
                transform={
                  mainContext.state.viewer.trail.showActionSettings
                    ? "grow-12 left-6"
                    : "grow-4"
                }
                color="white"
              />
            </Typography>
          </Box>
          <Box className="box-default" hidden={loading}>
            <Typography variant="h6" color="primary">
              Runner Zone
            </Typography>
            <Box className="box-default">
              <Typography variant="subtitle2" color="white">
                Manage your eventuator
              </Typography>
            </Box>
          </Box>

          <Box className="box-default">
            <Box
              className="box-default"
              sx={{
                pb: configEntzy.APP_SPACING_HL,
              }}
            >
              <Box
                className="box-default"
                sx={{
                  pt: configEntzy.APP_SPACING_MD2X,
                  pb: configEntzy.APP_SPACING_MD2X,
                  opacity: 0.5,
                }}
              >
                <Typography variant="h6">
                  <FontAwesomeIcon icon={iconRunner} size="2x" fixedWidth />
                  <FontAwesomeIcon
                    icon={iconSettings}
                    size="2x"
                    className="fa-spin"
                    style={{
                      "--fa-animation-duration": "1s",
                      "--fa-animation-iteration-count": "1",
                    }}
                    fixedWidth
                  />
                </Typography>
              </Box>
              <Box
                className="box-default"
                sx={{
                  pl: configEntzy.APP_SPACING_M2L,
                  pr: configEntzy.APP_SPACING_M2L,
                }}
              >
                {loading ? (
                  <Box
                    className="box-default"
                    sx={{
                      pt: configEntzy.APP_SPACING_HL3X,
                    }}
                  >
                    <ActionLoader />
                  </Box>
                ) : (
                  <Container maxWidth="sm">
                    {sectionList.map((section) => {
                      return (
                        <Box
                          key={section.id}
                          className="box-default"
                          sx={{
                            mt: section.blockHeader
                              ? configEntzy.APP_SPACING_LG
                              : 0,
                            pb: configEntzy.APP_SPACING_SM2X,
                          }}
                        >
                          <Box
                            className={
                              "box-default" +
                              (sections.includes(section.id)
                                ? " shadow-highlight"
                                : "")
                            }
                            sx={{
                              p: configEntzy.APP_SPACING_XS2X,
                            }}
                          >
                            <ActionBoxButton
                              size="medium"
                              bgColor={
                                section.bgColor ? section.bgColor : "dusk.dark"
                              }
                              color={section.color ? section.color : "white"}
                              text={section.text}
                              onClick={() => handleActionToggle(section)}
                              endIcon={
                                <FontAwesomeIcon
                                  icon={
                                    mainContext.state.actionDrawer.open &&
                                    mainContext.state.actionDrawer.params
                                      .section === section.id
                                      ? iconClose
                                      : section.icon
                                  }
                                  fixedWidth
                                  transform="grow-8 left-2"
                                />
                              }
                            />
                          </Box>
                        </Box>
                      );
                    })}
                  </Container>
                )}
              </Box>
            </Box>
            {/* <Box
                className="box-default"
                sx={{
                  pt: configEntzy.APP_SPACING_MD,
                  pb: configEntzy.APP_SPACING_MD2X,
                  opacity: 0.5,
                }}
              >
                <Typography variant="subtitle1">
                  <em>Use the highlighted sections to edit this area</em>
                </Typography>
              </Box> */}
          </Box>
          {/* <Box
              className="box-default"
              sx={{
                p: configEntzy.APP_SPACING_MD2X,
              }}
            >
              <ActionCore {...props} room="dates" icon={iconDates} />
            </Box> */}
        </Box>
      </Drawer>
    </Box>
  );
}

export default RoomRunnerZone;
